const state = {
  messageList: []
}

const getters = {
  MessageList: (state) => state.messageList
}

export const mutations = {
  pushMessage: function (state, payload) {
    let message = {
      Header: payload.header,
      Message: payload.message,
      MessageLink: payload.messageLink,
      MessageLinkText: payload.messageLinkText,
      IsError: payload.IsError,
      IsSticky: payload.sticky !== false,
      AutoHeight: payload.AutoHeight
    }
    state.messageList.push(message)
  },
  pushTimedMessage: function (state, payload) {

    let message = {
      Header: payload.header,
      Message: payload.message,
      MessageLink: payload.messageLink,
      MessageLinkText: payload.messageLinkText,
      IsError: payload.IsError,
      IsSticky: payload.sticky !== false,
      AutoHeight: payload.AutoHeight
    }
    let len = state.messageList.push(message);

    if(!payload.IsError){

      var maxSecondsToShowMessages = 10;
      var secondsToShow = Math.min(payload.seconds, maxSecondsToShowMessages);
      
      setTimeout(function () {
        state.messageList.splice(len - 1)
      }, secondsToShow * 1000);
    }
    
  },
  removeMessage: function (state, index) {
    state.messageList.splice(index, 1)
  },
  removeAllMessages: function(state){
    state.messageList = []
  }
}

export default {
  state,
  getters,
  mutations
}
